export const perfomAsync = (callback) => {
  setTimeout(() => {
    callback()
  })
};
